import { useNavigate } from "react-router-dom";
import { ArrowRight, X, Sparkles } from "lucide-react";

export const UnlockCelebration = ({ open, onClose }) => {
  const navigate = useNavigate();
  if (!open) return null;

  const goUnlock = () => { onClose(); navigate("/paywall"); };

  return (
    <div data-testid="unlock-celebration-overlay" className="fixed inset-0 z-[100] bg-ink/95 backdrop-blur-sm flex items-center justify-center p-5 animate-in fade-in duration-300">
      <div className="relative max-w-[560px] w-full border border-line bg-surface overflow-hidden animate-in zoom-in-95 duration-300">
        {/* Bauhaus geometry */}
        <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-gold/15" aria-hidden />
        <div className="absolute top-0 left-0 w-2 h-full bg-gold" aria-hidden />

        <button onClick={onClose} data-testid="unlock-celebration-close" className="absolute top-4 right-4 text-ash hover:text-cream transition-colors z-10">
          <X size={20} />
        </button>

        <div className="p-8 md:p-12">
          <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-gold">
            <Sparkles size={14} /> Your card is live
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold tracking-tighter uppercase text-cream mt-4 leading-[0.95]">
            Now go meet<br />your people.
          </h2>
          <p className="text-ash mt-5 leading-relaxed">
            Your HausCard is out there — but browsing is where the magic happens. Unlock the Haus to hear every writer, filter by role &amp; genre, and request intros to your next collaborator.
          </p>

          <div className="flex items-baseline gap-4 mt-7 font-mono text-sm text-cream">
            <span><span className="font-heading text-2xl font-bold text-gold">$59</span>/yr</span>
            <span className="text-ash">or</span>
            <span><span className="font-heading text-2xl font-bold text-gold">$8</span>/mo</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <button onClick={goUnlock} data-testid="unlock-celebration-cta" className="inline-flex items-center justify-center gap-2 bg-gold text-ink font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-gold-hi transition-colors">
              Unlock the Haus <ArrowRight size={16} />
            </button>
            <button onClick={onClose} data-testid="unlock-celebration-later" className="inline-flex items-center justify-center border border-line text-ash font-mono text-xs uppercase tracking-widest px-6 py-4 hover:text-cream hover:border-gold transition-colors">
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
